import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { searchAnalyses } from '../../common/engine/services/structuredAnalysisService';

export const initialState = {
  loading: false,
  error: null,
  analyses: null,
};

export const getAnalysesList = createAsyncThunk(
  'structuredAnalysisEdit/getAnalyses',
  async ({ projectId, type }) => {
    const response = await searchAnalyses(projectId, type);
    return response;
  }
);

const getAnalysesSlice = createSlice({
  name: 'getAnalyses',
  initialState,
  reducers: {},
  extraReducers: {
    [getAnalysesList.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [getAnalysesList.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.error = null;
      state.analyses = payload;
    },
    [getAnalysesList.rejected]: (state, { error }) => {
      state.loading = false;
      state.error = error;
      state.analyses = null;
    },
  },
});

export const { reducer: getAnalysesReducer } = getAnalysesSlice;

export const getAnalysesSelector = (state) => state.analysesList;
